import { render, staticRenderFns } from "./CardMedal.vue?vue&type=template&id=1b939756&"
import script from "./CardMedal.vue?vue&type=script&lang=js&"
export * from "./CardMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports